export default {
  groupLevel: 'CITY',
  outputFields: ['name', 'iataCode', 'cityName'],
  size: 1000,
  sortingDetails: [{ field: 'cityName', order: 'ASC' }],
  setting: { airportSource: 'LAMBDA', routeSource: 'LAMBDA' },
};
